import { Component, OnDestroy } from '@angular/core';
import { TRANSLOCO_SCOPE } from '@jsverse/transloco';
import { IPathwayEnrollmentResponse } from 'src/app/interfaces/ipathway-enrollment';
import { ConfettiService } from 'src/app/services/learner/confetti.service';
import { PathwayEnrollmentStatus } from 'src/app/utils/enums/learner/pathway.enum';

@Component({
  selector: 'app-learning-pathway',
  templateUrl: './learning-pathway.component.html',
  styleUrls: ['./learning-pathway.component.scss'],
  standalone: false,
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: 'assignment',
    },
  ],
})
export class LearningPathwayComponent implements OnDestroy {
  isEnrollmentCompleted = false;
  completedAt: string | null = null;
  pathwayName = '';

  constructor(private confettiService: ConfettiService) {}

  ngOnDestroy(): void {
    this.confettiService.stop();
  }

  onEnrollmentLoaded(enrollment: IPathwayEnrollmentResponse): void {
    this.isEnrollmentCompleted = enrollment.status === PathwayEnrollmentStatus.COMPLETED;
    this.completedAt = enrollment.completedAt;

    if (this.isEnrollmentCompleted) {
      this.confettiService.launchForEnrollment(enrollment.enrollmentUuid);
    }
  }
}

